/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./userassetsstat.vue?vue&type=template&id=d0ac0f8a&scoped=true"
import script from "./userassetsstat.vue?vue&type=script&lang=js"
export * from "./userassetsstat.vue?vue&type=script&lang=js"
import style0 from "./userassetsstat.vue?vue&type=style&index=0&id=d0ac0f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ac0f8a",
  null
  
)

export default component.exports